// extracted by mini-css-extract-plugin
export default {"mclRowContainer":"mclRowContainer---Q8XC2"};